export default function ChangeColor(color) {
  color = color.replace(/[^\d,]/g, "").split(",");
  return `rgb(${+color[0] - 45} , ${+color[1] - 49} , ${+color[2] - 51})`;
}
